import React, { useState, useEffect } from 'react';
import './aboutmain.css';
import aboutImage1 from '../../assets/aboutusimage/aboutnest/pexels-fauxels-3184298.jpg';
import aboutImage2 from '../../assets/aboutusimage/aboutnest/pexels-kindelmedia-7688439.jpg';
import Navbar from '../navbar/Navbar';
import Formpage from '../Formpage/Formpage';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Aboutus() {
      const [show, setShow] = useState(false);
      const handleShow = () => setShow(true);
      const handleClose = () => setShow(false);

      
        useEffect(() => {
          AOS.init({
            duration: 1000,
            once: true,
          });
      
          setTimeout(() => {
            AOS.refresh();
          }, 500);
        }, []);

  return (
    <>
      <div className="aboutus-section">
        <Navbar />

        <section className='section-margin'>
          <center>
            <div className='heading-for-all' data-aos='fade-up'>
              <h2>About Us</h2>
            </div>
          </center>
        </section>
        {/* First Block: Image Left, Text Right */}
        <div className='container'>
          <div className="aboutus-row">
            <div className="aboutus-image" data-aos='fade-right' data-aos-left='1000'>
              <img src={aboutImage1} alt="Team working" />
            </div>
            <div className="aboutus-content" data-aos='fade-left' data-aos-left='1000'>
              <p>
                At <span className='text-change'>Electiaa</span>,, we blend creativity, technology, and strategy to deliver digital solutions that drive real results.
                As a full-service agency, we specialize in website design, web development, and digital marketing, helping
                businesses build a strong online presence and grow in the digital era.
              </p>
              <p>
                Our integrated approach aligns design and marketing goals, helping us to not only capture attention but also
                convert interest into lasting customer relationships.
              </p>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <button className="button-all" onClick={handleShow} >Read More</button>

              </div>          </div>
          </div>

          {/* Second Block: Text Left, Image Right */}
          <div className="aboutus-row aboutus-reverse">
            <div className="aboutus-image" data-aos='fade-right' data-aos-left='2000'>
              <img src={aboutImage2} alt="Marketing Strategy" />
            </div>
            <div className="aboutus-content" data-aos='fade-left' data-aos-left='2000'>
              <p>
                From eye-catching websites to fully functional web platforms, our design and development team brings your vision
                to life with precision and innovation.
              </p>
              <p>
                We don’t just create websites — we build digital experiences that are fast, responsive, and user-centric.
                Our digital marketing experts craft tailored campaigns across SEO, social media, Google Ads, and more —
                ensuring your brand reaches the right audience at the right time.
              </p>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <button className="button-all" onClick={handleShow} >Read More</button>

              </div>
            </div>

          </div>
        </div>
      </div>
       <Formpage show={show} onClose={handleClose} />
        
    </>
  );
}

export default Aboutus;
